export default __webpack_public_path__ + "static/media/728-90.29ac5c9d.png";